import { useRouter } from 'next/navigation'

import { getFormattedDate } from '@/src/utils/date'
import { getflightsHistory, updateHomeSearch } from '@/src/utils/storage/recentSearch'
import { useSearchInputManager } from '@/src/components/desktop/srp/searchHeader/searchModifierInputs/hooks/search-inputs-manager'

/**
 * Custom hook that extends the existing useSearchInputManager for home page specific behavior
 * Reuses all existing logic and only overrides the search behavior to navigate to /flights/results
 */
export const useHomePageSearchManager = () => {
    const router = useRouter()
    const recentSearches = getflightsHistory()
    // Reuse the existing search input manager for all state and logic
    const searchManager = useSearchInputManager(undefined, undefined, recentSearches[0] || {})

    // Override the search behavior for home page
    const performHomePageSearch = () => {
        const queryParams = new URLSearchParams()
        queryParams.set('from', searchManager.fromToInputsState.from.airportCode as string)
        queryParams.set('to', searchManager.fromToInputsState.to.airportCode as string)
        queryParams.set('adults', searchManager.travelersState.adults.toString())
        queryParams.set('childs', searchManager.travelersState.childs.toString())
        queryParams.set('infants', searchManager.travelersState.infants.toString())
        queryParams.set('class', searchManager.flightClassState as string)
        queryParams.set('depart_date', getFormattedDate(searchManager.range.from, 'DD/MM/YYYY'))
        queryParams.set(
            'return_date',
            searchManager.isRoundTrip ? getFormattedDate(searchManager.range.to, 'DD/MM/YYYY') : ''
        )
        queryParams.set('origin', searchManager.fromToInputsState.from.value as string)
        queryParams.set('destination', searchManager.fromToInputsState.to.value as string)

        // Save search to recent searches
        const searchData = {
            from: searchManager.fromToInputsState.from.airportCode as string,
            to: searchManager.fromToInputsState.to.airportCode as string,
            origin: searchManager.fromToInputsState.from.value as string,
            destination: searchManager.fromToInputsState.to.value as string,
            sourceCountry: searchManager.fromToInputsState.from.airportCode as string,
            destinationCountry: searchManager.fromToInputsState.to.airportCode as string,
            adults: searchManager.travelersState.adults,
            childs: searchManager.travelersState.childs,
            infants: searchManager.travelersState.infants,
            class: searchManager.flightClassState as string,
            depart_date: getFormattedDate(searchManager.range.from, 'DD/MM/YYYY'),
            return_date: searchManager.isRoundTrip ? getFormattedDate(searchManager.range.to, 'DD/MM/YYYY') : '',
            intl: 'n', // Default to domestic, can be enhanced later
            rnd_one: searchManager.isRoundTrip ? 'round' : 'oneway',
            sd: 1
        }
        updateHomeSearch(searchData)

        const queryString = queryParams.toString()
        const url = `/en/flights/results?${queryString}`
        router.push(url)
    }

    // Return all existing functionality plus the home page specific search
    return {
        ...searchManager,
        performHomePageSearch
    }
}
